import React, { useState, useEffect } from "react";
import MediaDisplayModal from './MediaDisplayModal';
import DocumentDisplayModal from './DocumentDisplayModal';
import { useAuth } from './auth/AuthContext';
import DocMimeTypes from '../services/DocMimeTypes'; 

const MediaViewer = () => {
    const [isOpenMediaPlayer, setIsOpenMediaPlayer] = useState(false);
    const [isOpenDocViewer, setIsOpenDocViewer] = useState(false);
    const [uploadStatus, setUploadStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [filesList, setFilesList] = useState([]);
    const [selectedFileId, setSelectedFileId] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState(null);
    const { secureFetch } = useAuth();

    const populateFilesList = async ()=> {
        setLoading(true);
        const response = await secureFetch('api/mediaplayer/videolist');
        const data = await response.json();
        setFilesList(data);
        setLoading(false);
    }

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file); // 'file' must match the backend parameter name

        try {
            setUploadStatus('Uploading...');
            const response = await secureFetch('api/mediaplayer/video', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                setUploadStatus('Upload successful!');
                populateFilesList(); // Refresh the file list
            } else {
                setUploadStatus('Upload failed.');
            }
        } catch (error) {
            setUploadStatus('Error occurred during upload.');
        }
    };

    const displayFileContent = (index) => {
        let fileid = filesList[index].id;
        setSelectedFileId(fileid);
        let fileName = filesList[index].fileName;
        setSelectedFileName(fileName);
        let fileExtn = fileName.substring(fileName.lastIndexOf('.') + 1)

        let documentTypes = Object.keys(DocMimeTypes);
        if (documentTypes.includes(fileExtn.toLowerCase())) {
            setIsOpenDocViewer(true);
        }
        else {
            // For media files, open the modal
            setIsOpenMediaPlayer(true)
        }
    }

    const toggleMediaPlayerVisible = () => {
        setIsOpenMediaPlayer(curVal => !curVal);
    }
    const toggleDocViewerVisible = () => {
        setIsOpenDocViewer(curVal => !curVal);
    }

    let renderFilesList = (files) => {
        var index = 0;
        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr class="table-primary">
                        <th>File Name</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        files.map((file, index) =>
                            <tr key={index}>
                                <td><a href="javascript:void(0)" onClick={() => displayFileContent(index)}>{file.fileName}</a></td>
                                <td>Delete</td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        );
    };

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderFilesList(filesList);

    useEffect(() => {
        populateFilesList();
    }, []);

    return (
        <>
            <div className="container-fluid">
                <h2>Media Viewer</h2>
                <div className="card mt-3">
                    <div className="card-header" id="resultHeader">
                        <h4 className="panel-title">
                            Media List
                        </h4>
                    </div>
                    <div id="resultItems" className="card-body">
                        {contents}
                    </div>
                    <div className="card-footer">
                        <h4>Upload new media file</h4>
                        <div class="mt-3">
                            <input type="file" onChange={handleFileUpload} />
                            <p>Upload Status: {uploadStatus}</p>
                        </div>
                        <MediaDisplayModal isOpen={isOpenMediaPlayer} toggle={toggleMediaPlayerVisible} fileId={selectedFileId} />
                        <DocumentDisplayModal isOpen={isOpenDocViewer} toggle={toggleDocViewerVisible} fileId={selectedFileId} fileName={selectedFileName} />
                    </div>
                </div>
            </div>

        </>
    );
};

export default MediaViewer;
